import classNames from 'classnames';
import React from 'react';
import { Module } from '@/components/utilities/content-modules/module-list/module-list';
import { ProfileModule } from '@/components/utilities/content-modules/profile-module-list/profile-module-list';
import styles from './module-lock-wrapper.module.scss';

type ModuleItem = Module | ProfileModule;
type LoyaltyIndependentModuleType = ModuleItem['$type'];

const loyaltyIndependentModules: LoyaltyIndependentModuleType[] = [
  'HeaderCarouselModuleDto',
  'MediaHeaderWithSearchModuleDto',
  'MinimalHeaderModuleDto',
  'ProfileNoLoyaltyWallHeadlessModuleDto',
  'SecondaryHeaderModuleDto',
];

const shouldLockModule = (module: ModuleItem): boolean => {
  return !loyaltyIndependentModules.includes(module.$type);
};

export const isLoyaltyRequired = (modules: ModuleItem[]): boolean => {
  return modules.some(
    item => item.$type === 'ProfileNoLoyaltyWallHeadlessModuleDto',
  );
};

export const isModuleLocked = (
  module: ModuleItem,
  modules: ModuleItem[],
): boolean => {
  return isLoyaltyRequired(modules) && shouldLockModule(module);
};

export interface ModuleLockWrapperProps<T extends ModuleItem> {
  children: React.ReactNode;
  module: T;
  modules: T[];
}

const ModuleLockWrapper = <T extends ModuleItem>({
  children,
  module,
  modules,
}: ModuleLockWrapperProps<T>) => {
  const hasLoyaltyWall = isLoyaltyRequired(modules);
  const isLocked = isModuleLocked(module, modules);

  if (!hasLoyaltyWall) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <div
      className={classNames(styles.component, {
        [styles.isLocked]: isLocked,
      })}
    >
      {children}
    </div>
  );
};

export default ModuleLockWrapper;
